<template>
  <div
    class="admin-sticky-header"
    :class="{ 'admin-sticky-header--stuck': hasActions && stuck }"
    :style="rootStyle"
    ref="rootEl"
  >
    <div
      v-if="$slots.title"
      class="admin-sticky-header__title"
      ref="titleEl"
    >
      <slot name="title" />
    </div>
    <div
      v-if="$slots.actions"
      class="admin-sticky-header__actions"
    >
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminStickyHeader",
  data() {
    return {
      titleHeight: 0,
      resizeObserver: null,
      stuck: false,
      rafId: null,
    };
  },
  computed: {
    rootStyle() {
      return {
        "--admin-sticky-title-height": `${this.titleHeight}px`,
      };
    },
    hasActions() {
      return !!this.$slots.actions;
    },
  },
  mounted() {
    this.updateTitleHeight();
    this.scheduleUpdateStuck();

    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateTitleHeight();
        this.scheduleUpdateStuck();
      });

      if (this.$refs.titleEl) {
        this.resizeObserver.observe(this.$refs.titleEl);
      }
    } else {
      window.addEventListener("resize", this.updateTitleHeight);
    }

    document.addEventListener("scroll", this.scheduleUpdateStuck, true);
    window.addEventListener("resize", this.scheduleUpdateStuck);
  },
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    window.removeEventListener("resize", this.updateTitleHeight);

    document.removeEventListener("scroll", this.scheduleUpdateStuck, true);
    window.removeEventListener("resize", this.scheduleUpdateStuck);

    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  },
  methods: {
    updateTitleHeight() {
      if (!this.$refs.titleEl) {
        this.titleHeight = 0;
        return;
      }

      this.titleHeight = this.$refs.titleEl.offsetHeight || 0;
    },
    scheduleUpdateStuck() {
      if (!this.hasActions) return;
      if (this.rafId) return;

      this.rafId = requestAnimationFrame(() => {
        this.rafId = null;
        this.updateStuckState();
      });
    },
    updateStuckState() {
      if (!this.$refs.rootEl) return;

      const rect = this.$refs.rootEl.getBoundingClientRect();
      const computedTop = window.getComputedStyle(this.$refs.rootEl).top || "0px";
      const stickyTop = Number.parseFloat(computedTop) || 0;

      if (!this.stuck) {
        this.stuck = rect.top <= stickyTop + 0.5;
      } else {
        this.stuck = rect.top <= stickyTop + this.titleHeight + 5;
      }
    },
  },
};
</script>
